(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  const cards = [...document.querySelectorAll('[js-ingredients="card"]')];
  const popup = document.querySelector('[js-ingredients="popup"]');
  const popupCloseButton = document.querySelector('[js-ingredients="popupClose"]');
  const backgroundOverlay = document.querySelector('[js-ingredients="backgroundOverlay"]');

  const galleryWrapper = document.querySelector('[js-ingredients="galleryWrapper"]');
  const popupHeading = document.querySelector('[js-ingredients="popupHeading"]');
  const popupDescription = document.querySelector('[js-ingredients="popupDescription"]');
  const productContainer = document.querySelector('[js-ingredients="productContainer"]');

  let swiper = {};

  console.log(blockData);
  
  init();

  function init() {
    initCarousel();
    setEventListeners();
  }

  function setEventListeners() {
    if (cards) {
      cards.forEach((card) => {
        card.addEventListener("click", handleCardClick);
      });
    }

    if (popupCloseButton) {
      popupCloseButton.addEventListener("click", hidePopup);
    }

    if (backgroundOverlay) {
      backgroundOverlay.addEventListener("click", hidePopup);
    }
  }

  function initCarousel() {
    swiper = new Swiper('[js-ingredients="gallery"]', {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  function handleCardClick(event) {
    if (!event?.target) {
      return;
    }

    const index = event.target.dataset.index;

    if (!index) {
      return;
    }

    showPopup(index)
  } 

  function showPopup(index) {
    if (!popup) {
      return;
    }

    updatePopupContent(index);
    
    popup.classList.toggle('is-hidden');
    handleBackgroundOverlay();
  }

  function updatePopupContent(index) {
    if (popupHeading) {
      popupHeading.innerText = blockData[index].heading
    }

    if (popupDescription) {
      popupDescription.innerHTML = blockData[index].description
    }

    if (!galleryWrapper) {
      return;
    }

    galleryWrapper.innerHTML = '';

    galleryWrapper.insertAdjacentHTML('afterbegin', getGalleryImageSnippet(index, 1));
    galleryWrapper.insertAdjacentHTML('afterbegin', getGalleryImageSnippet(index, 2));
    galleryWrapper.insertAdjacentHTML('afterbegin', getGalleryImageSnippet(index, 3));

    swiper.update();

    updatePopupProducts(index);
  }

  function updatePopupProducts(index) {
    if (!productContainer) {
      return;
    }
    
    productContainer.innerHTML = '';

    productContainer.insertAdjacentHTML('afterbegin', getProductSnippet(index, 1));
    productContainer.insertAdjacentHTML('afterbegin', getProductSnippet(index, 2));
    productContainer.insertAdjacentHTML('afterbegin', getProductSnippet(index, 3));
  }

  function getProductSnippet(index, productIndex) {
    const imageObjectKey = `product_image_${productIndex}`;
    const titleObjectKey = `product_title_${productIndex}`;
    const urlObjectKey = `product_url_${productIndex}`;

    const imageSrc = blockData[index][imageObjectKey];
    const title = blockData[index][titleObjectKey];
    const url = blockData[index][urlObjectKey];

    if (!imageSrc || !title || !url) {
      return '';
    }

    return `
      <a 
        class="ingredients__popup-product-wrapper"
        href="${url}"
        class="ingredients__popup-product"
        js-ingredients="product"
      >
        <img
          class="ingredients__popup-product-image"
          src="${imageSrc}"
          alt="${title}"
        />

        <h6 class="ingredients__popup-product-name">
          ${title}
        </h6>
      </a>
    `;
  }

  function getGalleryImageSnippet(index, imageIndex) {
    const objectKey = `popup_image_${imageIndex}`;
    const imageSrc = blockData[index][objectKey];

    if (!imageSrc) {
      return '';
    }

    return ` 
      <img
        class="ingredients__gallery-image swiper-slide"
        src="${imageSrc}"
        alt="${blockData[index].heading}"
      />
    `;
  }

  function hidePopup() {
    if (!popup) {
      return;
    }

    popup.classList.add('is-hidden');
    handleBackgroundOverlay();
  }

  function handleBackgroundOverlay() {
    if (!backgroundOverlay) {
      return;
    }

    backgroundOverlay.classList.toggle('is-hidden');

    // Disable/Enable body scroll
    if (backgroundOverlay.classList.contains('is-hidden')) {
      document.body.style.height = 'initial';
      document.body.style.overflowY = 'initial';
    } else {
      document.body.style.height = '100vh';
      document.body.style.overflowY = 'hidden';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
